/* eslint-disable @typescript-eslint/ban-types */
import { useTheme } from '@emotion/react';
import type { ComponentProps, ComponentsNames, Theme } from '@sds-system/types';

type UseGetInternalProps = <Name extends ComponentsNames>(
  name: Name,
) => ComponentProps[Name] | undefined;
export const useGetInternalProps: UseGetInternalProps = <Name extends ComponentsNames>(
  name: Name,
) => {
  const theme = useTheme() as Theme;
  return theme.components?.[name]?.defaultProps as ComponentProps[Name] | undefined;
};
